import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { parseStyles } from "@circle-react-shared/BuilderUI/utils/parseStyles";

interface Testimonial2Props
  extends Omit<ComponentPropsWithRef<"div">, "content"> {
  content: ReactNode;
  image?: ReactNode;
  styles?: Record<string, StyleValue>;
  userCard: ReactNode;
}

export const Testimonial2 = forwardRef<HTMLDivElement, Testimonial2Props>(
  ({ userCard, content, image, styles = {}, className, ...rest }, ref) => {
    const inlineStyles = parseStyles({ styles });

    return (
      <div
        ref={ref}
        className={classNames(
          "wb-bg-primary wb-flex wb-flex-col wb-gap-5 wb-rounded-[1.25rem] wb-border",
          className,
        )}
        style={inlineStyles}
        {...rest}
      >
        {image}
        {content}
        {userCard}
      </div>
    );
  },
);
Testimonial2.displayName = "Testimonial2";
